import { put, takeLatest } from 'redux-saga/effects';
import {getByEntry, getBlogPosts} from '../utils/contentful_util';
import {formatted_posts,formatted_persons} from '../lib/contentful_formatter';

function* SAGA_CONTENTFUL_GET_POSTS(action){
    const {type} = action.value;
    const content_type = type || 'blogPost';
    const params = {
        content_type
    };

    const result = yield getBlogPosts(params);
    yield
    if(result && result.items){

        switch (content_type){
            case "blogPost":
                let posts = result.items && formatted_posts(result.items);
                yield put({type:"SET_PARAM", value:{key:'posts', val:posts}});
                break;
            default:
                console.log(content_type);
                let persons = result.items && formatted_persons(result.items);
                yield put({type:"SET_PARAM", value:{key:'persons', val:persons}});
                break;
        }
    }
}

function* SAGA_CONTENTFUL_GET_ENTRY(action){
    const {id} = action.value;
    if (!id) return;

    const result = yield getByEntry(id);
    yield
    if(result){
        console.log("getByENtry", id, result);
    }
}

export default function* contentfulWatcher() {
    yield takeLatest("SAGA_CONTENTFUL_GET_POSTS",  SAGA_CONTENTFUL_GET_POSTS);
    yield takeLatest("SAGA_CONTENTFUL_GET_PERSON", SAGA_CONTENTFUL_GET_POSTS);
    yield takeLatest("SAGA_CONTENTFUL_GET_ENTRY",  SAGA_CONTENTFUL_GET_ENTRY);
}


